import Skyflow from 'skyflow-js';
import { IEnvironment } from './enviroment.model';

export const environment: IEnvironment = {
  production: true,
  apiUrl: 'https://api.hostelhop.io',
  strapiUrl: 'https://cms-a5buyscvha-oa.a.run.app/',
  sentryDsn:
    'https://d67dfcc3a10e551c3620abbfe60932a8@o4506357240496128.ingest.sentry.io/4506357241544704',
  cdnUrl: 'https://storage.hostelhop.io',
  vaultID: 'e8c02fea566545689f4c5089ec14d487',
  vaultURL: 'https://db14325bdea3.vault.skyflowapis.com',
  skyflowEnv: Skyflow.Env.PROD,
  pwaUrl: 'https://app.hostelhop.io/#/search/pwa/',
  mailchimpApiKey: '399c29e94fbe135de4e1a85767d121e7-us14',
};
